import {
  isKnownKycStatus,
  isKycUnderReviewStatus,
  KYC_STATUS_VARIANTS,
} from "constants/kycStatusVariants";

export type RetailerKycEntry =
  | { type: "under_review"; reason: "review_queue" | "unknown" }
  | { type: "wizard"; mode: "fresh"; clearPriorData: boolean }
  | { type: "wizard"; mode: "resume" };

/**
 * Decides what the retailer app shows after GET /v1/kyc/customers/{id}.
 * Under-review and unknown statuses must never open the wizard.
 */
export function resolveRetailerKycEntry(
  status: string | null | undefined
): RetailerKycEntry {
  if (isKycUnderReviewStatus(status)) {
    return { type: "under_review", reason: "review_queue" };
  }
  if (!isKnownKycStatus(status)) {
    return { type: "under_review", reason: "unknown" };
  }
  if (status === KYC_STATUS_VARIANTS.REJECTED) {
    return { type: "wizard", mode: "fresh", clearPriorData: true };
  }
  if (
    status === KYC_STATUS_VARIANTS.PENDING ||
    status === KYC_STATUS_VARIANTS.KYC_INITIATED
  ) {
    return { type: "wizard", mode: "fresh", clearPriorData: false };
  }
  return { type: "wizard", mode: "resume" };
}

/** True when the completion screen should say "submitted / under review" instead of verified-complete. */
export function isPostSubmitUnderReviewStatus(
  status: string | null | undefined
): boolean {
  return status !== KYC_STATUS_VARIANTS.VERIFIED;
}

/**
 * After PAN, if same-PAN verified siblings exist and backend adopted this customer to VERIFIED
 * with bank details, skip Bank A/C and open Review.
 */
export function shouldOpenReviewAfterPanForLateJoiner(params: {
  associatedCount: number;
  kycStatus?: string | null;
  hasBankDetails: boolean;
}): boolean {
  return (
    params.associatedCount > 0 &&
    params.kycStatus === KYC_STATUS_VARIANTS.VERIFIED &&
    params.hasBankDetails
  );
}
